import { getUrl } from "aws-amplify/storage";
import {
  UseDistrictGeoJSON,
  UseDistrictProperty
} from "common/interfaces/UseDistrictGeoJSON";
import { PMTiles } from "pmtiles";
import { invokeGetPresignedUrlForAnonymous } from "../api/s3";
import { pbfToGeoJson } from "./pbfToGeoJson";

const pmtilesCache: Map<string, Promise<PMTiles>> = new Map();

export const getUseDistrictsGeoJSON = async (
  tileOnZoom20: string,
  forAnonymous: boolean
): Promise<UseDistrictGeoJSON | undefined> => {
  try {
    const [xStr, yStr] = tileOnZoom20.split(",");
    const x = Number(xStr);
    const y = Number(yStr);
    const z = 20;
    const mockMode = process.env.REACT_APP_MOCK_GML === "true";

    const path = "json/use_districts/tiles/z04-20.pmtiles";
    const pmtilesKey = `public/${path}`;
    const pmtilesUrl = mockMode
      ? `http://localhost:20099/${path}`
      : await (
          forAnonymous
            ? invokeGetPresignedUrlForAnonymous(pmtilesKey, "unauthenticated")
            : getUrl({
                path: pmtilesKey,
                options: { expiresIn: 1 * 60 * 60 }
              }).then((url) => url.url.href)
        ).catch(() => undefined);

    if (!pmtilesUrl) {
      return undefined;
    }

    let pmtilesPromise = pmtilesCache.get(pmtilesUrl);
    if (!pmtilesPromise) {
      pmtilesPromise = new Promise<PMTiles>((resolve) => {
        const instance = new PMTiles(pmtilesUrl);
        resolve(instance);
      });
      pmtilesCache.set(pmtilesUrl, pmtilesPromise);
    }

    const p = await pmtilesPromise;

    const tile = await p.getZxy(z, x, y);

    if (tile) {
      const geoJson = pbfToGeoJson<UseDistrictProperty>(tile.data, x, y, z);

      return { ...geoJson } as UseDistrictGeoJSON;
    }
  } catch (e) {
    console.warn("Failed to fetch/parse PMTiles:", e);
    return undefined;
  }

  return undefined;
};
